/** Upper bound on what one slide asks the CDN for (px). */
const MAX_SLIDE_SIZE = 1440;
/** Past 3× the extra pixels are paid for and not seen. */
const MAX_PIXEL_RATIO = 3;

/**
 * The size a full-bleed feed slide asks its preview for, in **device** pixels.
 *
 * Sized off the longest viewport side and multiplied by `devicePixelRatio` —
 * both deliberately, and both unlike the tiles (a flat 400) and the lightbox
 * (CSS pixels, no ratio, for bandwidth). A slide is the largest image the app
 * shows, on the screen users look at longest, and it is cropped to `cover`, so
 * the CSS-pixel width the lightbox settles for arrives upscaled threefold on a
 * modern phone — visibly soft beside a single-output slide, which renders
 * `media.url` as published. Taking the longest side also keeps the request
 * right whichever dimension `to=min&r=N` binds N to.
 *
 * The CDN only downsizes, so asking past the source returns it unchanged, and
 * the WebP that comes back is typically smaller than the original the
 * single-output path already ships.
 */
const getSlideImageSize = (): number => {
  if (typeof window === 'undefined') return MAX_SLIDE_SIZE;

  const ratio = Math.min(window.devicePixelRatio || 1, MAX_PIXEL_RATIO);
  const longestSide = Math.max(window.innerWidth, window.innerHeight);

  return Math.min(Math.round(longestSide * ratio), MAX_SLIDE_SIZE);
};

export default getSlideImageSize;
